import React from 'react';
import { connect } from 'react-redux';

import { setAuthenticationStep } from '../../../../../../redux/store/session/sessionOperations';
import { openModal } from '../../../../../../redux/store/modal/modalActions';

import { handleRegistrationButtonClick } from '../../../../../../helpers/handleRegistrationButtonClick';
import useWindowWidth from '../../../../../../hooks/useWindow';
import IconBloggers from './IconComponent';

import Bloggers from '../../../../../../assets/images/landing/header/bloggers.png';
import './styles.scss';

const SubHeader = ({ openModal, setAuthenticationStep, t }) => {
  const width = useWindowWidth();

  return (
    <div className="header-bloggers-bottom">
      <div className="header-bloggers-bottom-left">
        <span className="header-bloggers-bottom-left-title">
          {t('bloggers_landing_title')}
        </span>
        <span className="header-bloggers-bottom-left-subtitle">
          {t('bloggers_landing_description')}
        </span>
        <span
          onClick={() =>
            handleRegistrationButtonClick(setAuthenticationStep, openModal)
          }
          className="header-bloggers-bottom-left-button"
        >
          {t('bloggers_landing_button')}
        </span>
      </div>
      <div className="header-bloggers-bottom-right">
        <div className="header-bloggers-bottom-right-img">
          <IconBloggers width={width} />
          <img
            src={Bloggers}
            className="header-bloggers-bottom-right-img-icon"
            alt="bloggers"
          />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  openModal,
  setAuthenticationStep,
};

export default connect(null, mapDispatchToProps)(SubHeader);
